'use client';

// Client
import { CreateClientPopup } from '@/features/clients/create/create-client-popup';
import { EditClientPopup } from '@/features/clients/edit/edit-client-popup';

// Invoice
import { CreateInvoicePopup } from '@/features/invoices/create/create-invoice-popup';
import { EditInvoicePopup } from '@/features/invoices/edit/edit-invoice-popup';
import { ImportInvoicePopup } from '@/features/invoices/import/import-invoice-popup';

// Product
import { CreateProductPopup } from '@/features/products/create/create-product-popup';
import { EditProductPopup } from '@/features/products/edit/edit-product-popup';

// Expense
import { CreateExpensePopup } from '@/features/expenses/create/create-expense-popup';
import { EditExpensePopup } from '@/features/expenses/edit/edit-expense-popup';

// Modular contexts
import { useClientContext } from '@/contexts/client-context';
import { useInvoiceContext } from '@/contexts/invoice-context';
import { useProductContext } from '@/contexts/product-context';
import { useExpenseContext } from '@/contexts/expense-context';

export const Popups = () => {
  const { state: client } = useClientContext();
  const { state: invoice } = useInvoiceContext();
  const { state: product } = useProductContext();
  const { state: expense } = useExpenseContext();

  return (
    <>
      {invoice.isCreateInvoicePopupOpen && <CreateInvoicePopup />}
      {invoice.isEditInvoicePopupOpen && <EditInvoicePopup />}
      {invoice.isImportInvoicePopupOpen && <ImportInvoicePopup />}

      {client.isCreateClientPopupOpen && <CreateClientPopup />}
      {client.isEditClientPopupOpen && <EditClientPopup />}

      {product.isCreateProductPopupOpen && <CreateProductPopup />}
      {product.isEditProductPopupOpen && <EditProductPopup />}

      {expense.isCreateExpensePopupOpen && <CreateExpensePopup />}
      {expense.isEditExpensePopupOpen && <EditExpensePopup />}
    </>
  );
};
